<template>
  <div id="search-content">
    <v-layout align-center justify-center row wrap>
      <v-flex xs12>
        <div class="display-1 head-page font-weight-bold">สะดวกกว่า</div>
        <div class="title head-page">ด้วยการค้นหาผลผลิตที่สนใจ</div>
      </v-flex>
      <v-flex pt-0 sm6 style="height:50px;" xs12>
        <transition name="slide-fade">
          <v-autocomplete
            @click="isOpen()"
            class="bottom-search-box"
            hide-details
            hide-no-data
            hide-selected
            outline
            placeholder="ชื่อผลผลิต"
            ref="test"
            single-line
            v-if="!dialog"
          >
            <v-btn @click="onSearch()" color="#5d5d5d" depressed slot="append">
              <v-icon color="#fff">search</v-icon>
            </v-btn>
          </v-autocomplete>
        </transition>
      </v-flex>
    </v-layout>
    <v-dialog transition="slide-y-reverse-transition" v-model="dialog" width="600">
      <v-card id="card-search">
        <v-card-text>
          <v-autocomplete
            :items="products"
            :loading="isLoading"
            :search-input.sync="search"
            @input="onSearch"
            class="bottom-search-box"
            hide-details
            hide-no-data
            hide-selected
            item-text="productname"
            item-value="productname"
            outline
            placeholder="ชื่อผลผลิต"
            ref="search"
            single-line
            v-model="searchContentText"
          >
            <v-btn @click="onSearch()" color="#5d5d5d" depressed slot="append">
              <v-icon color="#fff">search</v-icon>
            </v-btn>
          </v-autocomplete>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import _ from 'lodash/orderBy'
export default {
  name: 'search-content',
  data() {
    return {
      searchContentText: '',
      isLoading: false,
      search: null,
      state: [],
      dialog: false,
      projects: []
    }
  },
  watch: {
    search() {
      // Items have already been loaded
      if (this.products.length > 0) return

      // Items have already been requested
      if (this.isLoading) return

      this.isLoading = true

      // Lazily load input items
      setTimeout(() => {
        this.state = _(this.$store.state.Product.searchProducts, ['id', 'orders'], ['asc', 'asc'])
        this.isLoading = false
      }, 1000)
    }
  },
  computed: {
    products() {
      return this.state
    }
  },
  methods: {
    isOpen() {
      this.dialog = !this.dialog
      setTimeout(() => {
        this.$refs.search.focus()
      }, 500)
    },
    findId(productName) {
      let productId = this.products
        .filter(item => item.productname == productName)
        .map(item => item.productid)
        .toString()
      return productId
      // this.$emit('input', { productId: productId, productName: productName })
    },
    async onSearch(value) {
      const productId = await this.findId(value)
      this.$router.push({
        name: 'product-search',
        params: { productId: window.btoa(productId) }
      })
      window.scrollTo(0, 0)
      // search log
      const ipAddress = await this.axios.get(`https://ipinfo.io/json?token=c4f8622271bdb1`)
      const data = {
        keyword: value,
        ip: ipAddress.data.ip,
        pages: 'search-bottom-page'
      }
      await this.axios.post(`farmerspace/search-log`, data)
    }
  }
}
</script>

<style lang="scss">
#search-content {
  .slide-fade-enter-active {
    transition: all 0.5s ease;
  }
  .slide-fade-leave-active {
    transition: all 0.5s ease;
  }
  .slide-fade-enter, .slide-fade-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-250px);
    opacity: 0;
  }
  .v-input__append-inner {
    margin-top: 0px;
    & .v-btn {
      border-radius: 0px;
      margin: 0px;
    }
  }
  .bottom-search-box {
    & .v-input__control {
      & .v-input__slot {
        min-height: 28px;
        border-radius: 0px;
        border: 1px solid #5d5d5d;
        padding-left: 20px;
        padding-right: 0px;
        & input {
          margin-top: 0px;
          font-size: 14px;
        }
        & .v-btn {
          min-width: 44px;
          width: 44px;
          height: 44px;
        }
        & ::placeholder {
          color: #000;
          font-size: 14px;
          letter-spacing: 2px;
        }
        & .v-icon {
          font-size: 26px;
        }
      }
    }
  }
}
#card-search {
  .v-input__append-inner {
    margin-top: 0px;
    & .v-btn {
      border-radius: 0px;
      margin: 0px;
    }
  }
  .bottom-search-box {
    & .v-input__control {
      & .v-input__slot {
        min-height: 28px;
        border-radius: 0px;
        border: 1px solid #5d5d5d;
        padding-left: 20px;
        padding-right: 0px;
        & input {
          margin-top: 0px;
          font-size: 14px;
        }
        & .v-btn {
          min-width: 44px;
          width: 44px;
          height: 44px;
        }
        & ::placeholder {
          color: #000;
          font-size: 14px;
          letter-spacing: 2px;
        }
        & .v-icon {
          font-size: 26px;
        }
      }
    }
  }
}
</style>
